




































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import FlatpageLegalBase from 'frontend/views/flatpages/FlatpageLegalBase.vue';

@Component({
  components: {
    FlatpageLegalBase,
  },
})
export default class CCPAPolicy extends Vue {}
